// import Vue from 'vue';
import router from '../router';

const state = {
  cart: [],
  rental: null,
};

const savedCart = JSON.parse(localStorage.getItem('cart'));
if (savedCart) {
  state.cart = savedCart;
}

const getters = {
  cartCount: state => state.cart.length,
  getCartTotal(state) {
    let total = 0;
    // eslint-disable-next-line no-restricted-syntax
    for (const item of state.cart) {
      // total += (item.price - item.unit_discount) * item.quantity;
      total += parseInt(item.price, 10) * parseInt(item.quantity, 10);
    }
    return total;
  },
  getRental: state => state.rental,
  getCart: state => state.cart,
  checkCartForItem: state => (productId) => {
    const item = state.cart.find(item => item.product_id === productId);
    return item !== undefined;
  },
};

const actions = {
  // async calculateDiscounts({ state, rootState, commit, dispatch }) {
  //   dispatch('alert/busy', null, { root: true });
  //   try {
  //     const customerId = rootState.account.profileId;
  //     const productIds = state.cart.map(item => item.id);
  //     const discountPrices = await apiService.getDiscountPrices(customerId, productIds);
  //     // eslint-disable-next-line no-restricted-syntax
  //     for (const item of state.cart) {
  //       const productId = item.product_id;
  //       // eslint-disable-next-line no-await-in-loop
  //       const priceDiscount = await apiService.getDiscountPrice(customerId, productId);
  //       item.price_discount = priceDiscount;
  //     }
  //     dispatch('alert/clear', null, { root: true });
  //   } catch (error) {
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // async addToCart({ rootState, dispatch, commit }, { piece, quantity }) {
  //   if (!rootState.account.account.loggedIn) {
  //     dispatch('alert/error', 'Please login to purchase art', { root: true });
  //   } else {
  //     try {
  //       const productId = piece.product_id;
  //       const customerId = rootState.account.account.user.customer_id;
  //       const res = await apiService.getDiscount(productId, customerId);
  //       const unitDiscount = res.discount;
  //       const lineItem = {
  //         art_id: piece.id,
  //         product_id: piece.product_id,
  //         title: piece.title,
  //         artist: piece.artist,
  //         images[0].url: piece.images[0].url,
  //         price: piece.price,
  //         unit_discount: unitDiscount,
  //         quantity,
  //       };
  //       commit('addToCart', lineItem);
  //       dispatch('alert/success', 'Added to cart', { root: true });
  //     } catch (error) {
  //       dispatch('alert/error', error, { root: true });
  //     }
  //   }
  // },
  // async deleteItem({ dispatch, commit }, item) {
  //   dispatch('alert/busy', null, { root: true });
  //   try {
  //     await apiService.deleteItem(item);
  //     const msg = 'Item canceled';
  //     dispatch('alert/success', msg, { root: true });
  //     commit('removeItem', item);
  //   } catch (error) {
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // async updateItem({ dispatch, commit }, item) {
  //   commit('setItemBusy', item);
  //   try {
  //     await apiService.updateItem(item);
  //     commit('clearItemBusy', item);
  //     commit('updateItem', item);
  //   } catch (error) {
  //     commit('clearItemBusy', item);
  //     dispatch('alert/error', error, { root: true });
  //   }
  // },
  // SOCKET_myActionSocket({ rootState, commit }, item) {
  //   // Websocket message on itemEvent channel
  //   if (rootState.account.account.user.type !== 'customer') {
  //     // Only fetch new items for service people
  //     commit('removeItem', item);
  //   }
  // },
};

const mutations = {
  addToCart(state, piece) {
    const lineItem = { ...piece };
    lineItem.quantity = 1;
    state.cart.push(lineItem);
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  stageRental(state, piece) {
    const lineItem = { ...piece };
    lineItem.quantity = 1;
    state.rental = lineItem;
    router.push('/rent');
  },
  removeFromCart(state, productId) {
    state.cart = state.cart.filter(item => item.product_id !== productId);
    localStorage.setItem('cart', JSON.stringify(state.cart));
  },
  emptyCart(state) {
    state.cart = [];
    localStorage.removeItem('cart');
  },
  // popItems(state, items) {
  //   state.items = items;
  // },
  // removeItem(state, item) {
  //   state.items = state.items.filter(item => item.id !== item.id);
  // },
  // updateItem(state, item) {
  //   // Check if item status is done. If so, we can just go ahead and remove it.
  //   if (item.status === 'done') {
  //     state.items = state.items.filter(item => item.id !== item.id);
  //   } else {
  //     const updatedItem = item;
  //     // Remove old item, and replace with new one
  //     const indexOfItem = state.items.findIndex(item => item.id === updatedItem.id);
  //     Vue.set(state.items, indexOfItem, updatedItem);
  //   }
  // },
  // SOCKET_myMutationSocket(state, { item, status }) {
  //   const oldItem = state.items.find(item => item.id === item);
  //   const updatedItem = { ...oldItem };
  //   updatedItem.status = status;
  //   // Replace item in state
  //   const indexOfItem = state.items.findIndex(item => item.id === item);
  //   Vue.set(state.items, indexOfItem, updatedItem);
  // },
};

export const cart = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/cart.module.js